var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F914(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FCEA2B"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36.2,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 62.3c-.3-1.2-.4-2.4-.3-3.6.2-1.1 2.3-6.5 2.7-7.3s1.4-4.5 2.4-4.8c1-.3 1.2.1 1.1.7s-.6 7.7-.6 7.7l9.4-2.8s7.7-1.9 7.9-1c2.1 2-5.4 4.5-7.5 4.4 0 0 1.1.6.9 1.3s-.8 1.2-1 1.2.5.5.6 1.4c.9 1.8-2.8 2.3-2.8 2.3 1.3-.2 3.3 2.1.1 2.7-1 .3-4.8 1.4-4.8 1.4s-3.3 1.2-5.2-.1c-1.2-.8-2.3-2-2.9-3.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M28.9 44.5c2.4-.7 11.9.5 14.1 2.1M22.4 22.5c1.3-.9 2.8-1.3 4.4-1.1 1.6 0 3.1.6 4.2 1.7M51.1 26.5c-2.7-.7-5.5-.8-8.2-.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M42 58.4c12.3-3.3 19.5-15.9 16.2-28.2S42.3 10.7 30 14c-10 2.7-17 11.8-17 22.2 0 4.6 1.4 9.2 4 13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30.7c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3 3 1.3 3 3M48 33.7c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3 3 1.3 3 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.7 56.7c-1 1.6-1.2 3.7-.5 5.5 1.1 3.3 4 5.2 7.2 4.2l4.9-1.4 1-.3c.8-.2 1.3-1.1 1.1-1.8h0c-.2-.5-.6-.9-1.2-1l1.2-.3c.8-.2 1.3-1.1 1.1-1.8-.2-.5-.6-1-1.2-1.1l1.2-.4c.8-.2 1.3-1.1 1.1-1.8-.1-.5-.5-.9-1-1l6.4-1.9c.8-.2 1.3-1.1 1.1-1.8s-1.1-1.3-1.8-1.1h0l-10.2 3-5.1 1.5.6-7.8c.1-.9-1.5-1.2-2.1.2l-3.8 9.1z"
  })));
}
export default Svg1F914;